"use strict";

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.define-property");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.getOptionLabel = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _useAutocomplete2 = _interopRequireDefault(require("@material-ui/lab/useAutocomplete"));

var _reactPopper = require("react-popper");

var _Flex = _interopRequireDefault(require("../Flex"));

var _Input = _interopRequireDefault(require("../Input"));

var _Label = _interopRequireDefault(require("../Label"));

var _Adornment = _interopRequireDefault(require("./Adornment"));

var _AutoLocation = _interopRequireDefault(require("./AutoLocation"));

var _Menu = _interopRequireDefault(require("./Menu"));

var _MenuItem = _interopRequireDefault(require("./Menu/MenuItem"));

var _useSize3 = _interopRequireDefault(require("../hooks/useSize"));

var _useTheme2 = _interopRequireDefault(require("../styles/useTheme"));

var _useRemoteOptions = _interopRequireDefault(require("./useRemoteOptions"));

var _useTranslation = _interopRequireDefault(require("./TranslationProvider/useTranslation"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

var useStyles = function useStyles() {
  var _useTheme = (0, _useTheme2["default"])(),
      spacing = _useTheme.spacing;

  return (0, _react.useMemo)(function () {
    return {
      popper: {
        zIndex: 1
      },
      menu: {
        margin: spacing(1, 0),
        maxHeight: spacing(28)
      },
      autoLocation: {
        justifyContent: 'flex-end',
        alignSelf: 'flex-end'
      }
    };
  }, [spacing]);
};

__signature__(useStyles, "useTheme{{ spacing }}\nuseMemo{}", function () {
  return [_useTheme2["default"]];
});

var getOptionLabel = function getOptionLabel(option) {
  var _ref = option || {},
      codeDepartement = _ref.codeDepartement,
      _ref$nom = _ref.nom,
      nom = _ref$nom === void 0 ? '' : _ref$nom;

  if (codeDepartement) {
    return "".concat(nom, " (").concat(codeDepartement, ")");
  }

  return nom;
};

exports.getOptionLabel = getOptionLabel;

var _ref3 = process.env.NODE_ENV === "production" ? {
  name: "g7snvd-PlacesAutocomplete",
  styles: "position:relative;;label:PlacesAutocomplete;"
} : {
  name: "g7snvd-PlacesAutocomplete",
  styles: "position:relative;;label:PlacesAutocomplete;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9QbGFjZXNBdXRvY29tcGxldGUvaW5kZXgudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWtJTSIsImZpbGUiOiIuLi8uLi9zcmMvUGxhY2VzQXV0b2NvbXBsZXRlL2luZGV4LnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCwgeyBDaGFuZ2VFdmVudCwgRnVuY3Rpb25Db21wb25lbnQsIE1vdXNlRXZlbnQsIHVzZUVmZmVjdCwgdXNlTWVtbywgdXNlU3RhdGUgfSBmcm9tICdyZWFjdCc7XG5cbmltcG9ydCB1c2VBdXRvY29tcGxldGUgZnJvbSAnQG1hdGVyaWFsLXVpL2xhYi91c2VBdXRvY29tcGxldGUnO1xuaW1wb3J0IHsgTWFuYWdlciwgUG9wcGVyLCBSZWZlcmVuY2UgfSBmcm9tICdyZWFjdC1wb3BwZXInO1xuXG5pbXBvcnQgRmxleCwgeyBGbGV4UHJvcHMgfSBmcm9tICcuLi9GbGV4JztcbmltcG9ydCBJbnB1dCwgeyBJbnB1dFByb3BzIH0gZnJvbSAnLi4vSW5wdXQnO1xuaW1wb3J0IExhYmVsLCB7IExhYmVsUHJvcHMgfSBmcm9tICcuLi9MYWJlbCc7XG5pbXBvcnQgQWRvcm5tZW50IGZyb20gJy4vQWRvcm5tZW50JztcbmltcG9ydCBBdXRvTG9jYXRpb24gZnJvbSAnLi9BdXRvTG9jYXRpb24nO1xuaW1wb3J0IE1lbnUgZnJvbSAnLi9NZW51JztcbmltcG9ydCBNZW51SXRlbSBmcm9tICcuL01lbnUvTWVudUl0ZW0nO1xuXG5pbXBvcnQgdXNlU2l6ZSBmcm9tICcuLi9ob29rcy91c2VTaXplJztcbmltcG9ydCB1c2VUaGVtZSBmcm9tICcuLi9zdHlsZXMvdXNlVGhlbWUnO1xuaW1wb3J0IHVzZVJlbW90ZU9wdGlvbnMsIHsgT3B0aW9uIH0gZnJvbSAnLi91c2VSZW1vdGVPcHRpb25zJztcblxuaW1wb3J0IHVzZVRyYW5zbGF0aW9uIGZyb20gJy4vVHJhbnNsYXRpb25Qcm92aWRlci91c2VUcmFuc2xhdGlvbic7XG5cbmV4cG9ydCBpbnRlcmZhY2UgUGxhY2VzQXV0b2NvbXBsZXRlUHJvcHMgZXh0ZW5kcyBPbWl0PEZsZXhQcm9wczwnZGl2Jz4sICdkZWZhdWx0VmFsdWUnIHwgJ29uQ2hhbmdlJz4ge1xuICBkZWZhdWx0VmFsdWU/OiBPcHRpb24gfCBudWxsO1xuICBtaW5WYWx1ZUxlbmd0aD86IG51bWJlcjtcbiAgb25DaGFuZ2U/OiAodmFsdWU/OiBPcHRpb24gfCBudWxsKSA9PiB2b2lkO1xuICBMYWJlbFByb3BzPzogTGFiZWxQcm9wcztcbiAgSW5wdXRQcm9wcz86IElucHV0UHJvcHM8J2lucHV0Jz47XG59XG5cbmNvbnN0IHVzZVN0eWxlcyA9ICgpID0+IHtcbiAgY29uc3QgeyBzcGFjaW5nIH0gPSB1c2VUaGVtZSgpO1xuICByZXR1cm4gdXNlTWVtbyhcbiAgICAoKSA9PiAoe1xuICAgICAgcG9wcGVyOiB7XG4gICAgICAgIHpJbmRleDogMSxcbiAgICAgIH0sXG4gICAgICBtZW51OiB7XG4gICAgICAgIG1hcmdpbjogc3BhY2luZygxLCAwKSxcbiAgICAgICAgbWF4SGVpZ2h0OiBzcGFjaW5nKDI4KSxcbiAgICAgIH0sXG4gICAgICBhdXRvTG9jYXRpb246IHtcbiAgICAgICAganVzdGlmeUNvbnRlbnQ6ICdmbGV4LWVuZCcsXG4gICAgICAgIGFsaWduU2VsZjogJ2ZsZXgtZW5kJyxcbiAgICAgIH0sXG4gICAgfSksXG4gICAgW3NwYWNpbmddXG4gICk7XG59O1xuXG5leHBvcnQgY29uc3QgZ2V0T3B0aW9uTGFiZWwgPSAob3B0aW9uPzogT3B0aW9uIHwgbnVsbCkgPT4ge1xuICBjb25zdCB7IGNvZGVEZXBhcnRlbWVudCwgbm9tID0gJycgfSA9IG9wdGlvbiB8fCB7fTtcbiAgaWYgKGNvZGVEZXBhcnRlbWVudCkge1xuICAgIHJldHVybiBgJHtub219ICgke2NvZGVEZXBhcnRlbWVudH0pYDtcbiAgfVxuICByZXR1cm4gbm9tO1xufTtcblxuY29uc3QgUGxhY2VzQXV0b2NvbXBsZXRlOiBGdW5jdGlvbkNvbXBvbmVudDxQbGFjZXNBdXRvY29tcGxldGVQcm9wcz4gPSAocHJvcHMpID0+IHtcbiAgY29uc3QgeyBtaW5WYWx1ZUxlbmd0aCA9IDMsIGRlZmF1bHRWYWx1ZSA9IG51bGwsIExhYmVsUHJvcHMsIElucHV0UHJvcHMsIG9uQ2hhbmdlLCBpZCwgLi4ub3RoZXIgfSA9IHByb3BzO1xuXG4gIGNvbnN0IGNsYXNzZXMgPSB1c2VTdHlsZXMoKTtcblxuICBjb25zdCBbaW5wdXRWYWx1ZSwgc2V0SW5wdXRWYWx1ZV0gPSB1c2VTdGF0ZSgoKSA9PiBnZXRPcHRpb25MYWJlbChkZWZhdWx0VmFsdWUpKTtcbiAgY29uc3QgW3ZhbHVlLCBzZXRWYWx1ZV0gPSB1c2VTdGF0ZTxPcHRpb24gfCBudWxsIHwgdW5kZWZpbmVkPihkZWZhdWx0VmFsdWUpO1xuICBjb25zdCBbb3Blbiwgc2V0T3Blbl0gPSB1c2VTdGF0ZShmYWxzZSk7XG4gIGNvbnN0IFtvcHRpb25zLCBzZXRPcHRpb25zXSA9IHVzZVN0YXRlPE9wdGlvbltdIHwgdW5kZWZpbmVkPihbXSk7XG5cbiAgY29uc3QgW3NpemUsIGNhcHR1cmVSZWZdID0gdXNlU2l6ZSgpO1xuICBjb25zdCB0ID0gdXNlVHJhbnNsYXRpb24oKTtcblxuICBjb25zdCBoYW5kbGVPbkNoYW5nZSA9IChlPzogQ2hhbmdlRXZlbnQ8SFRNTElucHV0RWxlbWVudD4sIG9wdGlvbj86IE9wdGlvbiB8IG51bGwpID0+IHtcbiAgICBzZXRJbnB1dFZhbHVlKGdldE9wdGlvbkxhYmVsKG9wdGlvbikpO1xuXG4gICAgc2V0VmFsdWUob3B0aW9uKTtcbiAgICBvbkNoYW5nZT8uKG9wdGlvbik7XG4gIH07XG5cbiAgY29uc3Qge1xuICAgIGdyb3VwZWRPcHRpb25zLFxuICAgIGdldElucHV0TGFiZWxQcm9wcyxcbiAgICBnZXRJbnB1dFByb3BzLFxuICAgIGdldExpc3Rib3hQcm9wcyxcbiAgICBnZXRSb290UHJvcHMsXG4gICAgZ2V0T3B0aW9uUHJvcHMsXG4gIH0gPSB1c2VBdXRvY29tcGxldGUoe1xuICAgIGlkLFxuICAgIG9wZW4sXG4gICAgdmFsdWUsIC8vIHNlbGVjdCB2YWx1ZVxuICAgIGlucHV0VmFsdWUsIC8vIHNlYXJjaCBpbnB1dCB2YWx1ZVxuICAgIGdldE9wdGlvbkxhYmVsLFxuICAgIG9wdGlvbnM6IG9wdGlvbnMgfHwgW10sXG4gICAgZmlsdGVyT3B0aW9uczogKG9wdGlvbikgPT4gb3B0aW9uLFxuICAgIGF1dG9IaWdobGlnaHQ6IHRydWUsIC8vIEF1dG8gaGlnaGxpZ2h0IGZpcnN0IGl0ZW1cbiAgICBhdXRvU2VsZWN0OiB0cnVlLCAvLyBNYWtlIGF1dG8tc2VsZWN0IGZpcnN0IGl0ZW0gd2hlbiBpbnB1dCBsb3NlcyBmb2N1c1xuICAgIG9uQ2hhbmdlOiBoYW5kbGVPbkNoYW5nZSBhcyBhbnksXG4gICAgb25JbnB1dENoYW5nZTogKGUpID0+IHtcbiAgICAgIHNldElucHV0VmFsdWUoKGUgYXMgQ2hhbmdlRXZlbnQ8SFRNTElucHV0RWxlbWVudD4pPy50YXJnZXQ/LnZhbHVlKTtcbiAgICB9LFxuICAgIG9uT3BlbjogKCkgPT4gc2V0T3Blbih0cnVlKSxcbiAgICBvbkNsb3NlOiAoKSA9PiBzZXRPcGVuKGZhbHNlKSxcbiAgICBnZXRPcHRpb25TZWxlY3RlZDogKG9wdGlvbj86IE9wdGlvbiwgdmFsdWU/OiBPcHRpb24pID0+IG9wdGlvbj8uY29kZSA9PT0gdmFsdWU/LmNvZGUsXG4gIH0pO1xuXG4gIGNvbnN0IGxhYmVsUHJvcHM6IGFueSA9IGdldElucHV0TGFiZWxQcm9wcygpO1xuICBjb25zdCBpbnB1dFByb3BzOiBhbnkgPSBnZXRJbnB1dFByb3BzKCk7XG4gIGNvbnN0IHJvb3RQcm9wczogYW55ID0gZ2V0Um9vdFByb3BzKCk7XG4gIGNvbnN0IGxpc3RCb3hQcm9wczogYW55ID0gZ2V0TGlzdGJveFByb3BzKCk7XG5cbiAgY29uc3QgaGFuZGxlT25DbGVhbiA9IChlOiBNb3VzZUV2ZW50KSA9PiB7XG4gICAgZS5wcmV2ZW50RGVmYXVsdCgpO1xuXG4gICAgaGFuZGxlT25DaGFuZ2UodW5kZWZpbmVkLCBudWxsKTtcbiAgICBzZXRPcGVuKGZhbHNlKTtcblxuICAgIC8qKiBUcnkgdG8gcmVmb2N1cyB0aGUgaW5wdXQgKi9cbiAgICBpbnB1dFByb3BzPy5yZWY/LmZvY3VzPy4oKTtcbiAgfTtcblxuICBjb25zdCBzdGF0ZSA9IHVzZVJlbW90ZU9wdGlvbnMoaW5wdXRQcm9wcy52YWx1ZSwgb3BlbiwgbWluVmFsdWVMZW5ndGgpO1xuICB1c2VFZmZlY3QoKCkgPT4gdm9pZCBzZXRPcHRpb25zKHN0YXRlLm9wdGlvbnMpLCBbc3RhdGUub3B0aW9uc10pO1xuXG4gIGNvbnN0IFtnZW9jb2RpbmdMb2FkaW5nLCBzZXRHZW9jb2RpbmdMb2FkaW5nXSA9IHVzZVN0YXRlKGZhbHNlKTtcblxuICBjb25zdCBDcm9zc0Fkb3JubWVudCA9IHVzZU1lbW8oKCkgPT4ge1xuICAgIGlmIChpbnB1dFZhbHVlPy5sZW5ndGggfHwgZ2VvY29kaW5nTG9hZGluZykge1xuICAgICAgcmV0dXJuIDxBZG9ybm1lbnQgb25DbGljaz17aGFuZGxlT25DbGVhbn0gbG9hZGluZz17c3RhdGUubG9hZGluZyB8fCBnZW9jb2RpbmdMb2FkaW5nfSAvPjtcbiAgICB9XG4gICAgcmV0dXJuIG51bGw7XG4gIH0sIFtpbnB1dFZhbHVlPy5sZW5ndGgsIGdlb2NvZGluZ0xvYWRpbmcsIGhhbmRsZU9uQ2xlYW4sIHN0YXRlLmxvYWRpbmddKTtcblxuICByZXR1cm4gKFxuICAgIDxGbGV4XG4gICAgICBjc3M9e3sgcG9zaXRpb246ICdyZWxhdGl2ZScgfX1cbiAgICAgIHJlZj17Y2FwdHVyZVJlZn1cbiAgICAgIGZsZXhEaXJlY3Rpb249XCJjb2x1bW5cIlxuICAgICAgbWFyZ2luPXtbMiwgMF19XG4gICAgICB7Li4ub3RoZXJ9XG4gICAgICB7Li4ucm9vdFByb3BzfVxuICAgID5cbiAgICAgIDxMYWJlbCBjb2xvcj17c3RhdGUuZXJyb3IgPyAnYWxlcnQnIDogJ3ByaW1hcnknfSB7Li4uTGFiZWxQcm9wc30gey4uLmxhYmVsUHJvcHN9PlxuICAgICAgICB7c3RhdGUuZXJyb3IgPyB0KCdjb3VsZF9ub3RfcmVhY2hfc2VydmVyJykgOiB0KCdjaXR5X3NlYXJjaF9sYWJlbCcpfVxuICAgICAgPC9MYWJlbD5cbiAgICAgIDxNYW5hZ2VyPlxuICAgICAgICA8UmVmZXJlbmNlPlxuICAgICAgICAgIHsoeyByZWYgfSkgPT4gKFxuICAgICAgICAgICAgPGRpdiByZWY9e3JlZn0+XG4gICAgICAgICAgICAgIDxJbnB1dFxuICAgICAgICAgICAgICAgIGlkPXtpZH1cbiAgICAgICAgICAgICAgICB2YXJpYW50PVwic3RhbmRhcmRcIlxuICAgICAgICAgICAgICAgIHBsYWNlaG9sZGVyPXt0KCdjaXR5X3NlYXJjaF9wbGFjZWhvbGRlcicpfVxuICAgICAgICAgICAgICAgIEFkb3JubWVudD17XG4gICAgICAgICAgICAgICAgICA8RmxleCBtYXJnaW49e1stMiwgMF19PlxuICAgICAgICAgICAgICAgICAgICB7Q3Jvc3NBZG9ybm1lbnR9XG4gICAgICAgICAgICAgICAgICAgIDxBdXRvTG9jYXRpb25cbiAgICAgICAgICAgICAgICAgICAgICBjc3M9e2NsYXNzZXMuYXV0b0xvY2F0aW9ufVxuICAgICAgICAgICAgICAgICAgICAgIG9uTG9hZGluZ1N0YXJ0ZWQ9eygpID0+IHNldEdlb2NvZGluZ0xvYWRpbmcodHJ1ZSl9XG4gICAgICAgICAgICAgICAgICAgICAgb25Mb2FkaW5nRW5kZWQ9eygpID0+IHNldEdlb2NvZGluZ0xvYWRpbmcoZmFsc2UpfVxuICAgICAgICAgICAgICAgICAgICAgIG9uU3VjY2Vzcz17KG9wdGlvbikgPT4gaGFuZGxlT25DaGFuZ2UodW5kZWZpbmVkLCBvcHRpb24pfVxuICAgICAgICAgICAgICAgICAgICAvPlxuICAgICAgICAgICAgICAgICAgPC9GbGV4PlxuICAgICAgICAgICAgICAgIH1cbiAgICAgICAgICAgICAgICBkaXNhYmxlZD17Z2VvY29kaW5nTG9hZGluZ31cbiAgICAgICAgICAgICAgICBlcnJvcj17ISFzdGF0ZS5lcnJvcn1cbiAgICAgICAgICAgICAgICB7Li4uaW5wdXRQcm9wc31cbiAgICAgICAgICAgICAgICB7Li4uSW5wdXRQcm9wc31cbiAgICAgICAgICAgICAgLz5cbiAgICAgICAgICAgIDwvZGl2PlxuICAgICAgICAgICl9XG4gICAgICAgIDwvUmVmZXJlbmNlPlxuXG4gICAgICAgIDxQb3BwZXIgY3NzPXtjbGFzc2VzLnBvcHBlcn0gcGxhY2VtZW50PVwiYm90dG9tLXN0YXJ0XCI+XG4gICAgICAgICAgeyh7IHJlZiwgc3R5bGUgfSkgPT4gKFxuICAgICAgICAgICAgPGRpdiByZWY9e3JlZn0gc3R5bGU9e3N0eWxlfT5cbiAgICAgICAgICAgICAgPE1lbnUgY3NzPXtjbGFzc2VzLm1lbnV9IHN0eWxlPXt7IHdpZHRoOiBzaXplLndpZHRoIH19IHsuLi5saXN0Qm94UHJvcHN9PlxuICAgICAgICAgICAgICAgIHtncm91cGVkT3B0aW9ucy5tYXAoKG9wdGlvbjogT3B0aW9uLCBpbmRleCkgPT4ge1xuICAgICAgICAgICAgICAgICAgY29uc3Qgb3B0aW9uUHJvcHMgPSBnZXRPcHRpb25Qcm9wcyh7IG9wdGlvbiwgaW5kZXggfSk7XG4gICAgICAgICAgICAgICAgICByZXR1cm4gKFxuICAgICAgICAgICAgICAgICAgICA8TWVudUl0ZW0ga2V5PXtpbmRleH0gey4uLm9wdGlvblByb3BzfT5cbiAgICAgICAgICAgICAgICAgICAgICB7Z2V0T3B0aW9uTGFiZWwob3B0aW9uKX1cbiAgICAgICAgICAgICAgICAgICAgPC9NZW51SXRlbT5cbiAgICAgICAgICAgICAgICAgICk7XG4gICAgICAgICAgICAgICAgfSl9XG4gICAgICAgICAgICAgIDwvTWVudT5cbiAgICAgICAgICAgIDwvZGl2PlxuICAgICAgICAgICl9XG4gICAgICAgIDwvUG9wcGVyPlxuICAgICAgPC9NYW5hZ2VyPlxuICAgIDwvRmxleD5cbiAgKTtcbn07XG5cbmV4cG9ydCBkZWZhdWx0IFBsYWNlc0F1dG9jb21wbGV0ZTtcbiJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

var PlacesAutocomplete = function PlacesAutocomplete(props) {
  var _props$minValueLength = props.minValueLength,
      minValueLength = _props$minValueLength === void 0 ? 3 : _props$minValueLength,
      _props$defaultValue = props.defaultValue,
      defaultValue = _props$defaultValue === void 0 ? null : _props$defaultValue,
      LabelProps = props.LabelProps,
      InputProps = props.InputProps,
      onChange = props.onChange,
      id = props.id,
      other = (0, _objectWithoutProperties2["default"])(props, ["minValueLength", "defaultValue", "LabelProps", "InputProps", "onChange", "id"]);
  var classes = useStyles();

  var _useState = (0, _react.useState)(function () {
    return getOptionLabel(defaultValue);
  }),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      inputValue = _useState2[0],
      setInputValue = _useState2[1];

  var _useState3 = (0, _react.useState)(defaultValue),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      value = _useState4[0],
      setValue = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      open = _useState6[0],
      setOpen = _useState6[1];

  var _useState7 = (0, _react.useState)([]),
      _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
      options = _useState8[0],
      setOptions = _useState8[1];

  var _useSize = (0, _useSize3["default"])(),
      _useSize2 = (0, _slicedToArray2["default"])(_useSize, 2),
      size = _useSize2[0],
      captureRef = _useSize2[1];

  var t = (0, _useTranslation["default"])();

  var handleOnChange = function handleOnChange(e, option) {
    setInputValue(getOptionLabel(option));
    setValue(option);
    onChange === null || onChange === void 0 ? void 0 : onChange(option);
  };

  var _useAutocomplete = (0, _useAutocomplete2["default"])({
    id: id,
    open: open,
    value: value,
    // select value
    inputValue: inputValue,
    // search input value
    getOptionLabel: getOptionLabel,
    options: options || [],
    filterOptions: function filterOptions(option) {
      return option;
    },
    autoHighlight: true,
    // Auto highlight first item
    autoSelect: true,
    // Make auto-select first item when input loses focus
    onChange: handleOnChange,
    onInputChange: function onInputChange(e) {
      var _ref2, _ref2$target;

      setInputValue((_ref2 = e) === null || _ref2 === void 0 ? void 0 : (_ref2$target = _ref2.target) === null || _ref2$target === void 0 ? void 0 : _ref2$target.value);
    },
    onOpen: function onOpen() {
      return setOpen(true);
    },
    onClose: function onClose() {
      return setOpen(false);
    },
    getOptionSelected: function getOptionSelected(option, value) {
      return (option === null || option === void 0 ? void 0 : option.code) === (value === null || value === void 0 ? void 0 : value.code);
    }
  }),
      groupedOptions = _useAutocomplete.groupedOptions,
      getInputLabelProps = _useAutocomplete.getInputLabelProps,
      getInputProps = _useAutocomplete.getInputProps,
      getListboxProps = _useAutocomplete.getListboxProps,
      getRootProps = _useAutocomplete.getRootProps,
      getOptionProps = _useAutocomplete.getOptionProps;

  var labelProps = getInputLabelProps();
  var inputProps = getInputProps();
  var rootProps = getRootProps();
  var listBoxProps = getListboxProps();

  var handleOnClean = function handleOnClean(e) {
    var _inputProps$ref, _inputProps$ref$focus;

    e.preventDefault();
    handleOnChange(undefined, null);
    setOpen(false);
    /** Try to refocus the input */

    inputProps === null || inputProps === void 0 ? void 0 : (_inputProps$ref = inputProps.ref) === null || _inputProps$ref === void 0 ? void 0 : (_inputProps$ref$focus = _inputProps$ref.focus) === null || _inputProps$ref$focus === void 0 ? void 0 : _inputProps$ref$focus.call(_inputProps$ref);
  };

  var state = (0, _useRemoteOptions["default"])(inputProps.value, open, minValueLength);
  (0, _react.useEffect)(function () {
    return void setOptions(state.options);
  }, [state.options]);

  var _useState9 = (0, _react.useState)(false),
      _useState10 = (0, _slicedToArray2["default"])(_useState9, 2),
      geocodingLoading = _useState10[0],
      setGeocodingLoading = _useState10[1];

  var CrossAdornment = (0, _react.useMemo)(function () {
    if ((inputValue === null || inputValue === void 0 ? void 0 : inputValue.length) || geocodingLoading) {
      return (0, _core.jsx)(_Adornment["default"], {
        onClick: handleOnClean,
        loading: state.loading || geocodingLoading
      });
    }

    return null;
  }, [inputValue === null || inputValue === void 0 ? void 0 : inputValue.length, geocodingLoading, handleOnClean, state.loading]);
  return (0, _core.jsx)(_Flex["default"], (0, _extends2["default"])({
    css: _ref3,
    ref: captureRef,
    flexDirection: "column",
    margin: [2, 0]
  }, other, rootProps), (0, _core.jsx)(_Label["default"], (0, _extends2["default"])({
    color: state.error ? 'alert' : 'primary'
  }, LabelProps, labelProps), state.error ? t('could_not_reach_server') : t('city_search_label')), (0, _core.jsx)(_reactPopper.Manager, null, (0, _core.jsx)(_reactPopper.Reference, null, function (_ref4) {
    var ref = _ref4.ref;
    return (0, _core.jsx)("div", {
      ref: ref
    }, (0, _core.jsx)(_Input["default"], (0, _extends2["default"])({
      id: id,
      variant: "standard",
      placeholder: t('city_search_placeholder'),
      Adornment: (0, _core.jsx)(_Flex["default"], {
        margin: [-2, 0]
      }, CrossAdornment, (0, _core.jsx)(_AutoLocation["default"], {
        css: classes.autoLocation,
        onLoadingStarted: function onLoadingStarted() {
          return setGeocodingLoading(true);
        },
        onLoadingEnded: function onLoadingEnded() {
          return setGeocodingLoading(false);
        },
        onSuccess: function onSuccess(option) {
          return handleOnChange(undefined, option);
        }
      })),
      disabled: geocodingLoading,
      error: !!state.error
    }, inputProps, InputProps)));
  }), (0, _core.jsx)(_reactPopper.Popper, {
    css: classes.popper,
    placement: "bottom-start"
  }, function (_ref5) {
    var ref = _ref5.ref,
        style = _ref5.style;
    return (0, _core.jsx)("div", {
      ref: ref,
      style: style
    }, (0, _core.jsx)(_Menu["default"], (0, _extends2["default"])({
      css: classes.menu,
      style: {
        width: size.width
      }
    }, listBoxProps), groupedOptions.map(function (option, index) {
      var optionProps = getOptionProps({
        option: option,
        index: index
      });
      return (0, _core.jsx)(_MenuItem["default"], (0, _extends2["default"])({
        key: index
      }, optionProps), getOptionLabel(option));
    })));
  })));
};

__signature__(PlacesAutocomplete, "useStyles{classes}\nuseState{[inputValue, setInputValue](() => getOptionLabel(defaultValue))}\nuseState{[value, setValue](defaultValue)}\nuseState{[open, setOpen](false)}\nuseState{[options, setOptions]([])}\nuseSize{[size, captureRef]}\nuseTranslation{t}\nuseAutocomplete{{\n    groupedOptions,\n    getInputLabelProps,\n    getInputProps,\n    getListboxProps,\n    getRootProps,\n    getOptionProps,\n  }}\nuseRemoteOptions{state}\nuseEffect{}\nuseState{[geocodingLoading, setGeocodingLoading](false)}\nuseMemo{CrossAdornment}", function () {
  return [useStyles, _useSize3["default"], _useTranslation["default"], _useAutocomplete2["default"], _useRemoteOptions["default"]];
});

var _default = PlacesAutocomplete;
var _default2 = _default;
exports["default"] = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(useStyles, "useStyles", "/builds/bA1zbJom/0/gojob/ui-bits/src/PlacesAutocomplete/index.tsx");
  reactHotLoader.register(getOptionLabel, "getOptionLabel", "/builds/bA1zbJom/0/gojob/ui-bits/src/PlacesAutocomplete/index.tsx");
  reactHotLoader.register(PlacesAutocomplete, "PlacesAutocomplete", "/builds/bA1zbJom/0/gojob/ui-bits/src/PlacesAutocomplete/index.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/PlacesAutocomplete/index.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();